import { Carousel, useCarouselController } from 'components/carousel'
import { css, useTheme } from '@fable/theme'
import { ClubDetailCarouselControls } from '../../ClubDetailCarouselControls'
import { CMSValueProp } from 'types'
import { ClubDetailValueProp } from './ClubDetailValueProp'
import { FlexBox } from '@fable/components'

export const ClubDetailValueProps = ({
  valueProps,
}: {
  valueProps: CMSValueProp[]
}) => {
  const { breakpoints, mediaQueries } = useTheme()
  const carouselController = useCarouselController()

  return (
    <div
      className={css`
        position: relative;
        ${mediaQueries.tabletL} {
          margin-top: 32px;
        }
      `}
    >
      <div
        data-testid="clubDetailValuePropsCarousel"
        className={css`
          display: none;
          ${mediaQueries.mobileL} {
            display: revert;
          }
        `}
      >
        <ClubDetailCarouselControls controller={carouselController} />
        <Carousel
          controller={carouselController}
          options={{
            slides: { perView: 'auto', spacing: 12, origin: 0 },
          }}
          childWidths={[
            { width: '85%', breakpoint: 'base' },
            { width: '332px', breakpoint: breakpoints.mobileL },
          ]}
          noOverflow
        >
          {valueProps?.map((item, i) => (
            <ClubDetailValueProp
              key={i}
              hide={i < carouselController.currentSlide}
              {...item}
            />
          ))}
        </Carousel>
      </div>
      <FlexBox
        data-testid="clubDetailValuePropsRows"
        className={css`
          ${mediaQueries.mobileL} {
            display: none;
          }
        `}
        flexDirection="column"
        alignItems="stretch"
        gap="16px"
      >
        {valueProps?.map((item, i) => (
          <ClubDetailValueProp key={i} row {...item} />
        ))}
      </FlexBox>
    </div>
  )
}
